<script setup lang="ts">
import { Badge } from '@/components/ui/badge'

import { useCommunicationTranslations } from '../../composables/useCommunicationTranslations'
import type { AcknowledgmentLevel } from '../../types/communication'

defineProps<{
  acknowledgmentLevel: AcknowledgmentLevel
  isPendingAcknowledgment: boolean
  isPendingSignature: boolean
  compact?: boolean
}>()

const { tm } = useCommunicationTranslations('communication')
</script>

<template>
  <div class="flex flex-wrap gap-1.5">
    <!-- Completed states -->
    <Badge
      v-if="acknowledgmentLevel === 'signed'"
      variant="secondary"
      :class="[
        'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-950 dark:text-emerald-300',
        compact ? 'text-[10px] px-1.5 py-0' : '',
      ]"
    >
      {{ compact ? tm('inbox.acknowledgment_level_signed') : tm('detail.acknowledgment_level_signed') }}
    </Badge>

    <Badge
      v-else-if="acknowledgmentLevel === 'accepted'"
      variant="secondary"
      :class="[
        'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-800 dark:bg-blue-950 dark:text-blue-300',
        compact ? 'text-[10px] px-1.5 py-0' : '',
      ]"
    >
      {{ compact ? tm('inbox.acknowledgment_level_accepted') : tm('detail.acknowledgment_level_accepted') }}
    </Badge>

    <Badge
      v-else-if="acknowledgmentLevel === 'read'"
      variant="secondary"
      :class="[
        'border-green-200 bg-green-50 text-green-700 dark:border-green-800 dark:bg-green-950 dark:text-green-300',
        compact ? 'text-[10px] px-1.5 py-0' : '',
      ]"
    >
      {{ tm('detail.acknowledgment_level_read') }}
    </Badge>

    <!-- Pending states -->
    <Badge
      v-if="isPendingSignature"
      variant="secondary"
      :class="[
        'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-300',
        compact ? 'text-[10px] px-1.5 py-0' : '',
      ]"
    >
      {{ tm('detail.signature_required') }}
    </Badge>

    <Badge
      v-else-if="isPendingAcknowledgment"
      variant="secondary"
      :class="[
        'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-300',
        compact ? 'text-[10px] px-1.5 py-0' : '',
      ]"
    >
      {{ tm('inbox.pending_acknowledgment') }}
    </Badge>
  </div>
</template>
